import {db, fb} from "../../firebase";
import {initialState} from "../Store/initialState";
import {updateUserState} from "../User/actions";

export const UPDATE_DETAIL_VALUE = "UPDATE_DETAIL_VALUE";
export const updateValue = (value) => {
    return (dispatch, getState) => {
        let payload = value;
        const userId = getState().user.userId;

        // Exists the user's answer in the result
        payload.whichChecked = (payload.result && userId in payload.result) ? payload.result[userId] : "";

        dispatch({type: "UPDATE_DETAIL_VALUE", payload: payload})
    }
};

export const selectAnswer = (questionId, type) => {
    return (dispatch, getState) => {
        const answererId = getState().user.userId;
        const path = `result.${answererId}`;
        if (type !== "") {
            return db.collection('questions').doc(questionId).update({[path]: type})
        } else {
            return db.collection('questions').doc(questionId).update({[path]: fb.firestore.FieldValue.delete()})
        }
    }
};

export const reportPostAsInappropriate = () => {
    return (dispatch, getState) => {
        const questionId = getState().detail.id;
        return db.collection('questions').doc(questionId).update({is_inappropriate: true})
    }
};

export const blockUser = () => {
    return async (dispatch, getState) => {
        let userState = getState().user;
        const userId = userState.userId;
        const blockedUserId = getState().detail.creator_id;
        await db.collection('users').doc(userId).set({block_users: {[blockedUserId]: true}},{merge:true})

        // Add the blocked user's id to block users state in Store
        userState.block_users[blockedUserId] = true;
        dispatch(updateUserState(userState))
    }
}

export const resetDetailState = () => {
    return {type: "UPDATE_DETAIL_VALUE", payload: initialState.detail}
};
